import { DataDisplayEvent, DropdownSelectionEvent, LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutCarrierPayDetail } from "./autogen/AutogenLayoutCarrierPayDetail";

const MARGINPERCENT = "MP";

export class CarrierPayDetail extends AutogenLayoutCarrierPayDetail {

    textboxMeasureOnDataDisplay(event: DataDisplayEvent) {
        const measure = event.rowData.get("measure");
        this.syncLayoutWithMeasure(measure);
    }

    textboxMeasureAfterDropdownSelection(event: DropdownSelectionEvent){
        const measure = event.selection?.value;
        this.syncLayoutWithMeasure(measure);
    }

    syncLayoutWithMeasure(measure: string){
        const isMargin = measure === MARGINPERCENT;
        this.panelMargin.visible = isMargin;
        this.textboxPayToCompare.visible = !isMargin;
        this.panelMarginDetail.visible = isMargin;
        this.panelNotMarginDetail.visible = !isMargin;
    }

    textboxOrderTypesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.is_active = 'Y';
    }
}